import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=3741bdfb&"
import script from "./DetailsModal.vue?vue&type=script&lang=js&"
export * from "./DetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3741bdfb')) {
      api.createRecord('3741bdfb', component.options)
    } else {
      api.reload('3741bdfb', component.options)
    }
    module.hot.accept("./DetailsModal.vue?vue&type=template&id=3741bdfb&", function () {
      api.rerender('3741bdfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/configurator/DetailsModal.vue"
export default component.exports